import React, { useMemo, useState } from 'react';
// @ts-ignore
import styles from './ManagerBasicData.module.scss';
import MagicForm from '../../../../../../Components/Form/MagicForm';
import useBasicData from '../../../../Hooks/useBasicData';
import { useWorkplaceBasicDataQuery } from '../../../../../../graphql/graphql';
import Loading from '../../../../../../Components/Loading';
import apiClient from '../../../../../../Services/ApiClient';
import useApiClient from '../../../../../Base/Hooks/useApiClient';

interface Props {
	workplaceId: string;
}

const ManagerBasicData: React.FC<Props> = ({ workplaceId }) => {
	const [isLoading, setIsLoading] = useState(false);
	const {
		data,
		isLoading: isLoadingBasicData,
		refetch,
	} = useWorkplaceBasicDataQuery({
		id: workplaceId,
	});
	const { formScheme } = useBasicData();
	const { displayError } = useApiClient();

	const defaultData = useMemo(() => {
		const workplace = data?.workplace;
		if (workplace) {
			return {
				...workplace,
				parentId: {
					label: workplace.parentWorkplace?.doctorDisplayName,
					value: workplace.parentWorkplace?.id,
				},
				fieldOfCare: workplace.termItems?.find(
					item => item?.term?.name === 'field_of_care',
				)?.id,
				formOfCare: workplace.termItems?.find(
					item => item?.term?.name === 'sukl_forma_pece',
				)?.id,
				icpNumber: workplace.meta?.find(item => item?.key === 'icp')?.value,
				iczNumber: workplace.meta?.find(item => item?.key === 'icz')?.value,
				defaultDoctorId: workplace.defaultDoctorId
					? { value: workplace.defaultDoctorId }
					: undefined,
			};
		}

		return undefined;
	}, [data]);

	const handleSubmit = async (values: any) => {
		setIsLoading(true);
		const {
			meta,
			fieldOfCare,
			formOfCare,
			createCaseTarget,
			onlineOrderTarget,
			icpNumber,
			iczNumber,
			defaultDoctorId,
			parentId,
			...restOfValues
		} = values;

		const termItems: { id: string }[] = [];
		const updateMeta: { key: string; value: string }[] = [];

		if (fieldOfCare) {
			termItems.push({ id: fieldOfCare.value || fieldOfCare });
		}

		if (formOfCare) {
			termItems.push({ id: formOfCare.value || formOfCare });
		}

		if (icpNumber) {
			updateMeta.push({
				key: 'icp',
				value: icpNumber,
			});
		}

		if (iczNumber) {
			updateMeta.push({
				key: 'icz',
				value: iczNumber,
			});
		}

		const data = {
			...restOfValues,
			termItems,
			meta: updateMeta,
			parentWorkplaceId: parentId.value,
			createCaseTarget: createCaseTarget?.value || createCaseTarget,
			onlineOrderTarget: onlineOrderTarget?.value || onlineOrderTarget,
			defaultDoctorId: defaultDoctorId?.value || defaultDoctorId,
		};

		try {
			const response = await apiClient.patch(
				`/workplaces/${workplaceId}`,
				data,
			);
			if (response.status === 200) {
				await refetch();
			}
		} catch (e) {
			displayError(e);
		}
		setIsLoading(false);
	};

	if (isLoading || isLoadingBasicData) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			<div className='row'>
				<div className='col-12 col-md-6'>
					<MagicForm
						formScheme={formScheme}
						onSubmit={handleSubmit}
						defaultValues={defaultData}
					/>
				</div>
			</div>
		</div>
	);
};

export default ManagerBasicData;
